import { useState, useCallback } from "react";

const useTableConfiguration = (defaultFilter = []) => {
  const [tableConfig, setTableConfig] = useState({
    columns: [],
    sort: {},
    search: [],
    filter: defaultFilter,
  });

  // handling filter from the table configuration
  const filter = tableConfig.filter;
  const setFilter = useCallback((value) => {
    setTableConfig((prevTableConfig) => ({
      ...prevTableConfig,
      filter: value,
    }));
  }, []);

  // handling search from the table configuration
  const handleTableConfigSearchChange = useCallback((column, searchKey) => {
    setTableConfig((prevTableConfig) => ({
      ...prevTableConfig,
      search: prevTableConfig.search
        .filter((existingValue) => existingValue.column !== column)
        .concat(searchKey ? [{ column, searchKey }] : []),
    }));
  }, []);

  const handleTableConfigSortChange = (column) => {
    const getOrder = (order) => {
      switch (order) {
        case "asc":
          return "desc";
        case "desc":
          return null;
        default:
          return "asc";
      }
    };
    const order = getOrder(tableConfig.sort.order);
    setTableConfig((prev) => ({
      ...prev,
      sort: order
        ? {
            column,
            order,
          }
        : {},
    }));
  };

  return {
    tableConfig,
    setTableConfig,
    filter,
    setFilter,
    handleTableConfigSearchChange,
    handleTableConfigSortChange,
  };
};

export default useTableConfiguration;
